<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 bg-head-light mb-2">
          <div class="col-lg-6 col-5">
            <h1 style="justify-content: center;" class="h3 mb-0"> Merchant Roll Requests </h1>
          </div>
          <div class="col-lg-6 col-7 text-right">
            <app-search-bar (searchChange)="onSearchChanged($event)" placeholder="Search by Tid / Merchant Name"></app-search-bar>
          </div>

        </div>
      </div>

    </div>
  </div>
  <!-- <h1 style="justify-content: flex; text-align: center; color: indianred;"> Accessories Request</h1> -->
  <div class="p-3">
    <!-- <button  class="btn btn-primary" (click)="open()">
      <span  class="spinner-border spinner-border-sm mr-1"></span>
        <strong>Add Request</strong>
    </button> -->
    <div>
      <ag-grid-angular style="
      width: 100%;
      height: 500px;"
      class="ag-theme-balham"
      [enableSorting]="true"
      [enableFilter]="true"
      [enableCellTextSelection]="true"
      [rowData]="rows"
      [pagination]="true"
      [columnDefs]="columnDefs">
      </ag-grid-angular>
    </div>
